module.exports = __webpack_public_path__ + "media/images/element/data-science-e1e9e5cbc150495ddc3d97ffcaf554e1.svg";